import React from 'react';
function useOnScreenKeyboard() {
  const [showKeyboard, setShowKeyboard] = React.useState(false);
  const [focusPosition, setFocusPosition] = React.useState(0);

  React.useEffect(() => {
    const handleFocus = (event: FocusEvent) => {
      const el = event.target as HTMLElement;
      const { tagName, type } = el as HTMLInputElement | HTMLTextAreaElement;
      const isInputElement = tagName === 'INPUT' || tagName === 'TEXTAREA';
      const isInputType = type === 'text' || type === 'email' || type === 'password' || type === 'search' || type === 'tel' || type === 'url';

      if (isInputElement && isInputType && el.getAttribute('data-vendex')) {
        setShowKeyboard(true);
        const focusPos = el.offsetTop + el.offsetHeight;
        setFocusPosition(focusPos);
      } else {
        setShowKeyboard(false);
      }
    };

    const handleBlur = () => {
      setShowKeyboard(false);
      setFocusPosition(0);
    };

    document.addEventListener('focus', handleFocus, true);
    document.addEventListener('blur', handleBlur, true);

    return () => {
      document.removeEventListener('focus', handleFocus, true);
      document.removeEventListener('blur', handleBlur, true);
    };
  }, []);

  return { showKeyboard, focusPosition };
}

export default useOnScreenKeyboard;
